module.exports = __webpack_public_path__ + "static/media/testen-er-ferdig.e632802a.mp3";